import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const ACTIVITYPLACE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ActivityPlace.Name')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
];

export const ACTIVITYPLACE_CONFIG = {
  entityName: 'ActivityPlace',
  localizationKey: 'Controlling::Entity.ActivityPlace',
  fields: ACTIVITYPLACE_FIELDS,
  permission: 'ControllingActivities.ActivityPlaces',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
